module.exports = __webpack_public_path__ + "static/media/tba.31744ac0.png";